var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorPlanMobileLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 52,
    viewBox: "0 0 28 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13608_21655)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13608_21655)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16689e-06 51.9996C0.0518246 51.9999 0.103677 52 0.155562 52C15.5336 52 28 40.3594 28 26C28 11.6406 15.5336 2.71598e-06 0.155571 2.71982e-08C0.103686 1.81263e-08 0.0518337 0.000132522 1.52587e-05 0.000397196L6.16689e-06 51.9996Z",
    fill: "#FBD207"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5947 16.67C13.9884 16.2871 14.6055 16.2571 15.0346 16.5998V16.5998C15.547 17.0092 15.5844 17.7752 15.1141 18.2325L7.12628 26L15.1141 33.7675C15.5844 34.2248 15.547 34.9908 15.0346 35.4002V35.4002C14.6055 35.7429 13.9884 35.7129 13.5947 35.33L4.00001 26L13.5947 16.67Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13608_21655",
    x: -4,
    y: -2,
    width: 36,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13608_21655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13608_21655",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13608_21655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlanMobileLeft);
export default __webpack_public_path__ + "static/media/floor_plan_mobile_left.2d10f8f7.svg";
export { ForwardRef as ReactComponent };